// extracted by mini-css-extract-plugin
var _1 = "LeL0DC8JwaZT1eoNecBB";
var _2 = "VjFXoyak8xsQ6MCnIgAp";
export { _1 as "bottom-container", _2 as "flex-container" }
